import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { Solution } from '../models/solution';
import { englishSolutions } from '../models/solutions';
import { frenchSolutions } from '../models/solutions';

@Injectable({
  providedIn: 'root'
})
export class SolutionService {

  selectedSolution: Solution;

  getEnglishSolutions(): Observable<Solution[]> {
    return of (englishSolutions)
  }

  getFrenchSolutions(): Observable<Solution[]> {
    return of (frenchSolutions)
  }

  constructor() { }
}
